export const BisheProjecte = `query BisheProjecte{
  bisheProjectes(sort: "number" ) {
   bisheProjectHeand{
    title
    label
    desc
    learnUrl
    objUrl
    imgurl{
      url
    }
  }
    contdata{
      icon{
        url
      }
      type
      title
      cont{
        title
        subTitle
        description
        url
        files{
          url
        }
        image{
          url
        }
      }
    }
    number
  }
}`